import script from "./OnboardingStep1.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardingStep1.vue?vue&type=script&setup=true&lang=ts"

import "./OnboardingStep1.vue?vue&type=style&index=0&id=c5c8cefc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5c8cefc"]])

export default __exports__